import { Config } from "@/shared/config";

const healthcareExpenseServiceUri = Config.HealthcareExpenseServicebaseUri;

export default {
  get healthcareExpenseV1 () {
    return `${healthcareExpenseServiceUri}/healthcareexpense/v1`;
  },
  getConditions (): string {
    return `${this.healthcareExpenseV1}/conditions`;
  },
  getForecastRequest (): string {
    return `${this.healthcareExpenseV1}/forecast/last-request`;
  },
  getHsaForecast (): string {
    return `${this.healthcareExpenseV1}/forecast`;
  },
  updateHsaForecast (): string {
    return `${this.healthcareExpenseV1}/forecast`;
  }
};